<template>
  <div class="relative overflow-hidden whitespace-nowrap bg-white">
    <div class="flex h-10 px-4 border cursor-pointer" @click="isSearchModalOpened = true">
      <div class="inline-flex items-center gap-2">
        <UIcon name="i-heroicons-magnifying-glass"/>
        <p class="flex self-center text-gray-500">{{ isSubCategoryPage ? 'Search for Products' : 'Search' }}</p>
      </div>

      <V4ListAnimateComponent  v-if=!isSubCategoryPage class="absolute top-2 left-[100px] text-gray-700 font-bold" :items="placeholder"/>
    </div>
  </div>
  <V4ResponsivePanel side="right" v-model="isSearchModalOpened">
    <div class="bg-inherit">
      <V4SearchModalComponent :filters="filters" @close="isSearchModalOpened = false"/>
    </div>
  </V4ResponsivePanel>
</template>

<script setup>
const props = defineProps({
  placeholder: { type: Array, default: [] },
  filters: { type: Object, default: {} }
});
const isSearchModalOpened = ref(false);
const route = useRoute();
const isSubCategoryPage = computed(() => route.path.includes('search-v2')); 
</script>